import loadable from '@loadable/component'

const PhoneInput = loadable(() => import('./PhoneInput'))
const PhoneInputField = loadable(() => import('./PhoneInputField'))

export default PhoneInput
export { PhoneInputField }
